export default "__VITE_ASSET__DGZHOm4___"